import React from "react";
import { Link } from "react-router-dom";

const cream = "#F5F0E8";
const darkBg = "#1a1025";
const mutedCream = "rgba(245,240,232,0.6)";
const purple = "#8B5CF6";

export default function LabManagerPrivacy() {
  return (
    <div className="min-h-screen" style={{ backgroundColor: darkBg, color: cream }}>
      <nav className="max-w-7xl mx-auto px-4 py-6 flex items-center justify-between">
        <Link to="/labmanager" className="flex items-center gap-3">
          <span className="text-2xl">🔬</span>
          <span className="text-xl font-bold" style={{ color: cream }}>LabManager</span>
        </Link>
      </nav>

      <div className="max-w-3xl mx-auto px-4 py-12">
        <h1 className="text-3xl md:text-4xl font-bold mb-8" style={{ color: cream }}>Privacy Policy</h1>
        <p className="text-sm mb-8" style={{ color: mutedCream }}>Last updated: March 7, 2026</p>

        <div className="space-y-8 text-sm leading-relaxed" style={{ color: mutedCream }}>
          <section>
            <h2 className="text-lg font-semibold mb-3" style={{ color: cream }}>Overview</h2>
            <p>LabManager is a local-first desktop application built by Plexys. Your privacy is fundamental to how we designed the product.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold mb-3" style={{ color: cream }}>Free Tier (Local-Only)</h2>
            <p>When using LabManager in free/local mode:</p>
            <ul className="list-disc list-inside mt-2 space-y-1">
              <li>All data is stored locally on your computer in a SQLite database</li>
              <li>No data is transmitted to our servers or any third party</li>
              <li>No analytics, tracking, or telemetry is collected</li>
              <li>No account or registration is required</li>
              <li>Your data remains entirely under your control</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold mb-3" style={{ color: cream }}>Team Tier (Cloud Sync)</h2>
            <p>When using LabManager Team with cloud sync enabled:</p>
            <ul className="list-disc list-inside mt-2 space-y-1">
              <li>Your lab data is synced to Supabase cloud infrastructure for real-time collaboration</li>
              <li>We collect your email address for authentication purposes</li>
              <li>Team data is isolated by team and protected by row-level security policies</li>
              <li>Data is encrypted in transit (TLS) and at rest</li>
              <li>We do not sell, share, or monetize your data</li>
              <li>Payment processing is handled by Stripe; we do not store credit card information</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold mb-3" style={{ color: cream }}>Data Storage</h2>
            <p><strong style={{ color: cream }}>Local data location:</strong></p>
            <ul className="list-disc list-inside mt-2 space-y-1">
              <li>macOS: ~/Library/Application Support/labmanager/</li>
              <li>Windows: %APPDATA%/labmanager/</li>
              <li>Linux: ~/.config/labmanager/</li>
            </ul>
            <p className="mt-2">You can delete your data at any time by removing this directory.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold mb-3" style={{ color: cream }}>Auto-Updates</h2>
            <p>LabManager checks GitHub Releases for updates. This sends a standard HTTP request containing your app version. No personal data is transmitted.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold mb-3" style={{ color: cream }}>HIPAA Considerations</h2>
            <p>LabManager's local-first architecture is designed to be HIPAA-friendly. Data stored locally never leaves your machine. If you use Team Sync with protected health information, you are responsible for ensuring your organization's compliance requirements are met.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold mb-3" style={{ color: cream }}>Contact</h2>
            <p>Questions about this privacy policy? Contact us at <a href="mailto:support@plexys.co" style={{ color: purple }}>support@plexys.co</a>.</p>
          </section>
        </div>
      </div>

      <footer className="py-10 border-t" style={{ borderColor: "rgba(139,92,246,0.15)" }}>
        <div className="max-w-7xl mx-auto px-4 flex flex-col md:flex-row items-center justify-between gap-4 text-sm" style={{ color: mutedCream }}>
          <p>&copy; {new Date().getFullYear()} Plexys. All rights reserved.</p>
          <div className="flex gap-6">
            <Link to="/labmanager" className="hover:opacity-100 transition">LabManager</Link>
            <Link to="/labmanager/terms" className="hover:opacity-100 transition">Terms of Service</Link>
            <Link to="/" className="hover:opacity-100 transition">Plexys Home</Link>
          </div>
        </div>
      </footer>
    </div>
  );
}
